import { useQuery } from '@tanstack/react-query';
import PageLoader from 'Components/PageLoader';
import React, { useEffect, useState } from 'react'
import toast from 'react-hot-toast';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom'
import { fetchVendorTounch } from 'services/Tounches';
import AdminHeading from '../AdminPanel/Heading/AdminHeading';
import VendorTouncheNew from './Vendor_tounche_new';

const EditVendorTounchNew = () => {
    const {id} = useParams()
    const allStates = useSelector((state) => state);
    const adminLoggedIn = allStates.reducer1;
    const clientCode = adminLoggedIn.ClientCode;
    const {
        data: VendorTounch,
        isLoading,
        isError:vendorTounchIsError,
        error:vendorTounchError
      } = useQuery({
        queryKey: ["vendorTounche/vendorTounchById",id,clientCode],
        queryFn: fetchVendorTounch,
        refetchOnWindowFocus: false,
        
      });
      useEffect(()=>{
        if(vendorTounchIsError && vendorTounchError){
          toast.error(vendorTounchError?.message,{
            position:"top-center",
            duration:2000
          })
        }
      },[vendorTounchIsError,vendorTounchError])
  return (
    <div>
        {isLoading && <PageLoader/>}
        {!isLoading && !vendorTounchIsError && (
        <VendorTouncheNew editStatus={true} editData={VendorTounch} editId={id}/>
        )}
    </div>
  )
}

export default EditVendorTounchNew
